import React, { createElement, useState, useEffect } from "react"
import PropTypes from "prop-types"
import Input from "ui-coopeuch-input"
import ClockHelper from "./ClockHelper.js"

import ClockIcon from "./assets/clock.svg"

import "./style.css"

const Helper = props => {
  const Error = ({ withIcon, message, withRetryButton, onRetry }) => {
    return (
      <small className="HelperError">
        {withIcon && (
          <img
            className="HelperError__img-icon"
            src={ClockIcon}
            alt="err-icon"
          />
        )}
        <p className="InputCoordinateCard__error-message">{message}</p>
        {withRetryButton && (
          <button
            className="HelperError__btn-retry"
            type="button"
            onClick={onRetry}
          >
            Reintentar
          </button>
        )}
      </small>
    )
  }


  const Custom = ({ content }) => content

  const types = {
    error: Error,
    custom: Custom,
    clock: Clock
  }

  return createElement(types[props.type || "clock"], props, null)
}

const Clock = ({
  secondsAvailableToRespond,
  loading,
  onChangeIsTimeUp,
  onRetry
}) => {
  return (
    <ClockHelper
      mode="timer"
      initialTime={secondsAvailableToRespond}
      complementaryText="para ingresar tus coordenadas."
      loading={loading}
      onChangeIsTimeUp={onChangeIsTimeUp}
      onRetry={onRetry}
    />
  )
}

const InputCoordinateCard = props => {
  const {
    coordinates,
    values,
    errorMessage,
    secondsAvailableToRespond,
    disabled,
    loading,
    customHelper,
    status,
    onChange,
    onTimeOverToRespond,
    onRetryRespond,
    onBlurInputCoordinate
  } = props

  const [localValues, setLocalValues] = useState(values)
  const [isTimeOverToRespond, setIsTimeOverToRespond] = useState(false)
  const [idxInputFocused, setIdxInputFocused] = useState(-1)
  const [
    localSecondsAvailableToRespond,
    setLocalSecondsAvailableToRespond
  ] = useState(-1)

  useEffect(() => {
    setLocalValues(values)
  }, [values])

  useEffect(() => {
    onChange(_generateExitEvent(localValues))
  }, [localValues])

  useEffect(() => {
    if (isTimeOverToRespond && onTimeOverToRespond) {
      setIdxInputFocused(-1)
      onTimeOverToRespond()
    }
  }, [isTimeOverToRespond])

  useEffect(() => {
    const isCoordinatesFilled = coordinates.every(c => c.length === 2)

    if (isCoordinatesFilled) {
      setIdxInputFocused(0)
      setLocalSecondsAvailableToRespond(secondsAvailableToRespond)
    } else setLocalSecondsAvailableToRespond(-1)
  }, [coordinates])

  const _generateExitEvent = values => {
    let result = { values }

    return _validateCoordinatesValues(values)
      ? { ...result, errors: _validateCoordinatesValues(values) }
      : { ...result }
  }

  const _validateCoordinatesValues = values => {
    if (
      !values.every(v => v.length === 2) ||
      values.length !== coordinates.length
    )
      return ["FORMAT"]
  }

  const handleChangeInput = (event, coordinateIdx) => {
    const newValues = [...localValues]
    const { value } = event.target
    newValues[coordinateIdx] = value
    setLocalValues(newValues)

    if (coordinateIdx < coordinates.length - 1 && value.length >= 2)
      setIdxInputFocused(coordinateIdx + 1)
  }

  const handleChangeIsTimeUp = isTimeUp => {
    setIsTimeOverToRespond(isTimeUp)
  }

  const handleRetry = () => {
    setIsTimeOverToRespond(false)
    onRetryRespond()
  }

  return (
    <section className="InputCoordinateCard">
      <form
        className={`InputCoordinateCard__form${
          status ||
          isTimeOverToRespond ||
          errorMessage ||
          customHelper?.type === "error"
            ? " InputCoordinateCard__form--error"
            : ""
        }`}
      >
        <legend className="InputCoordinateCard__input-group">
          {coordinates.map((c, i) => (
            <div key={i}>
              <Input
                label={c || "00"}
                value={localValues[i]}
                name={`coordinate-${i}`}
                type="password"
                maxLength={2}
                disabled={disabled || isTimeOverToRespond}
                loading={loading}
                focused={idxInputFocused === i}
                onChange={e => handleChangeInput(e, i)}
                onBlur={() => {
                  setIdxInputFocused(-1)
                  onBlurInputCoordinate && onBlurInputCoordinate(localValues)
                }}
              />
            </div>
          ))}
        </legend>
        <section className="InputCoordinateCard__countdown">
          {errorMessage ? (
            <p className="InputCoordinateCard__error-message">{errorMessage}</p>
          ) : (
            <Helper
              {...customHelper}
              {...props}
              secondsAvailableToRespond={localSecondsAvailableToRespond}
              onChangeIsTimeUp={e => handleChangeIsTimeUp(e)}
              onRetry={handleRetry}
            />
          )}
        </section>
      </form>
    </section>
  )
}

InputCoordinateCard.defaultProps = {
  coordinates: [],
  values: [],
  errorMessage: "",
  secondsAvailableToRespond: -1,
  disabled: false,
  customHelper: {
    type: "",
    message: "",
    withRetryButton: true,
    withIcon: true,
    onRetry: () => {}
  },
  onChange: () => {},
  onTimeOverToRespond: () => {},
  onRetryRespond: () => {},
  onBlurInputCoordinate: () => {}
}

InputCoordinateCard.propTypes = {
  coordinates: PropTypes.array,
  values: PropTypes.array,
  errorMessage: PropTypes.string,
  secondsAvailableToRespond: PropTypes.number,
  disabled: PropTypes.bool,
  customHelper: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
    withRetryButton: PropTypes.bool,
    withIcon: PropTypes.bool,
    onRetry: PropTypes.func
  }),
  onChange: PropTypes.func,
  onTimeOverToRespond: PropTypes.func,
  onRetryRespond: PropTypes.func,
  onBlurInputCoordinate: PropTypes.func
}

export default InputCoordinateCard
